export default __webpack_public_path__ + "static/media/swap-form.9cfe8c65.jpg";